import type { PlayerCardComponentSpec } from "../Processing/types";
import type { ControlPanelHandler } from "../widgetContract";

// A Player Card holds exactly one player, while the Control Panel emits a multi-subject
// selection (players/positions/groups/drills). We only apply when the selection resolves
// to a single athlete — one `player-<id>` value and no drills. Positions, groups,
// "Full Team", multi-select, or drill selections leave the card untouched (a single
// card can't represent them). Date is ignored — the card has no date range.
export const playerCardControlPanel: ControlPanelHandler<PlayerCardComponentSpec> = (spec, patch) => {
  if (!patch.applySubjects) return;
  const { selectedSubjects, selectedDrills } = patch.subjects;
  if (selectedDrills.length > 0 || selectedSubjects.length !== 1) return;

  const only = selectedSubjects[0];
  if (!only.startsWith("player-")) return;

  const playerId = Number(only.slice("player-".length));
  if (Number.isNaN(playerId)) return;

  spec.player_id = playerId;
};
